import Layout2 from '@/layout/Layout2'

export default [{
  path: '/posts',
  component: Layout2,
  meta: { requiresAuth: true },
  children: [{
    path: '',
    component: () => import('@/components/posts/Posts')
  }, {
    path: 'create',
    component: () => import('@/components/posts/CreatePost')
  }, {
    path: 'edit/:id',
    component: () => import('@/components/posts/EditPost'),
    props: true
  }]
}]
